import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleDonateClick = () => {
        // Scroll to donation section or open modal
        console.log('Donate clicked');
    };

    return (
        <nav className={`navbar navbar-expand-lg navbar-light fixed-top ${scrolled ? 'navbar-scrolled' : ''}`}>
            <div className="container-fluid">
                <Link className="navbar-brand brand-animated" to="/">
                    <Icon icon="medical-icon:health-services" className="brand-icon" />
                    <span className="brand-text">HSCF</span>
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0 pt-lg-0 pt-4">
                        <li className="nav-item px-2">
                            <Link className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} to="/">
                                Home
                            </Link>
                        </li>

                        <li className="nav-item px-2">
                            <Link className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} to="/about">
                                About
                            </Link>
                        </li>

                        <li className="nav-item dropdown px-2">
                            <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Programs
                            </a>
                            <ul className="dropdown-menu">
                                <li><Link className="dropdown-item" to="/programs">Our Implementation Model</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><h6 className="dropdown-header">HSCF-owned Initiatives</h6></li>
                                <li><Link className="dropdown-item" to="/programs/educateher">&nbsp;&nbsp;→ EducateHer</Link></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><h6 className="dropdown-header">Signature White Label Initiatives</h6></li>
                                <li><Link className="dropdown-item" to="/programs/rtygia">&nbsp;&nbsp;→ RTYGIA</Link></li>
                                {/*<li><Link className="dropdown-item" to="/programs/aikpokpodion-fellowship">&nbsp;&nbsp;→ Aikpokpodion Fellowship</Link></li>*/}
                            </ul>
                        </li>

                        <li className="nav-item px-2">
                            <Link className={`nav-link ${location.pathname === '/updates' ? 'active' : ''}`} to="/updates">
                                News & Updates
                            </Link>
                        </li>


                        {/*
                        <li className="nav-item px-2">
                        <a className="nav-link" href="https://globalhealthmirror.org" target="_blank" rel="noopener noreferrer">
                            <Icon icon="mdi:earth" className="nav-icon" />
                            Global Health Mirror
                            <Icon icon="material-symbols:open-in-new" className="external-icon" />
                        </a>
                        </li>
                        */}

                        {/*
                        <li className="nav-item px-2">
                        <Link className={`nav-link ${location.pathname === '/resources' ? 'active' : ''}`} to="/resources">
                            Resources
                        </Link>
                        </li>
                        */}

                        <li className="nav-item px-2">
                            <Link className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact">
                                Contact
                            </Link>
                        </li>
                    </ul>

                    {/*
                    <button className="btn btn-donate ms-lg-3" onClick={handleDonateClick}>
                        <Icon icon="mdi:hand-heart" className="me-2" />
                        Donate Now
                    </button>
                    */}

                </div>
            </div>
        </nav>
    );
}

export default Navbar;
